import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magellen-health',
  templateUrl: './magellen-health.component.html',
  styleUrls: ['./magellen-health.component.sass']
})
export class MagellenHealthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
